import Administration from "../../../../src/pages/administration/administration";
import * as React from 'react';
export default {
  Administration,
  React
};